import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SignInTemplate from 'shared/components/SignInTemplate'
import LoginForm from './forms/Login/form'

const invalidCredentialsError = "Invalid Credentials"
const connectionError = "Error occurred while trying to establish connection to authentication service"

export default class Login extends Component {

    constructor(props, context) {
        super(props, context)
        this.actions = {
            onLoginSubmit: (model) => this.onLoginSubmit(model)
        }
        this.queryParam = "?goto="
    }

    componentDidMount() {
        this.props.actions.getCsrfToken()
    }

    errorMessage() {
        return this.props.error ?
            this.props.error.status === 400 ?
                invalidCredentialsError : connectionError : null
    }

    onLoginSubmit(model) {
        this.props.actions.signIn({
            credentials: model,
            CSRF: this.props.CSRF
        })
    }

    redirectToQueryParam() {
        if (this.props.authenticated)
            window.location.assign(this.props.location.search.substring(this.queryParam.length))
    }

    render() {
        this.redirectToQueryParam()
        return (
            <SignInTemplate>
                <LoginForm actions={this.actions}
                           isLoading={this.props.isLoading}
                           error={this.props.error !== undefined}
                           errorMessage={this.errorMessage()}/>
            </SignInTemplate>
        )
    }
}

Login.propTypes = {
    actions: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/screens/login/components/index.js